import React, { Component } from 'react';
import HtmlToReact from 'html-to-react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import {BtnStart, BtnBlockSum, BtnTA, BtnBlocking, BtnResetBlk, BtnGuide, BtnInfoNext, BtnInfoFinish} from '../Buttons/info.js';
import Transition from '../Misc/Transition.js';



class CourseInfo extends Component {

  constructor(props){
    super(props);
    this.htmlToReact = new HtmlToReact.Parser();
  }

  getButtons(){
    //Render start if lesson not yet mounted
    if(!this.props.course.mountLesson){
      return <BtnStart key='start' onClick = {this.props.mountLesson} />;
    } else {
      return this.props.info.buttons.map((button) => {
        switch(button) {
          case 'thinkAloud':
            return <BtnTA key='ta' running = {this.props.thinkaloud.running} onClick = {this.props.startThinkaloud}/>;
          case 'blockSummary':
            return <BtnBlockSum key="blk-sum-save" disabled = {() => this.props.blockSummary.disabled} onClick = {this.props.submitSummaries} />
          case 'blockingSave':
            return <BtnBlocking key="blk-save" blocking = {() => this.props.blocking} onClick = {this.props.saveBlocks} />
          case 'blockingReset':
            return <BtnResetBlk onClick = {this.props.resetBlocks} key="blk-reset"/>
          case 'infoNext':
            return <BtnInfoNext key="next" course={this.props.course} onClick={this.props.changeLesson} />
          case 'infoFinish':
            return <BtnInfoFinish key="finish" course={this.props.course} />
          case 'guide':
            return <BtnGuide key="guide" onClick = {this.props.enableGuide} />
          default:
            return null;
        }
      });
    }
  }

  getList(){
    const {list, listHeading} = this.props.info;

    if(list.length < 1 || listHeading.length < 1 )
      return
    else
      return [
        <h3 key="list-heading" id="list-heading">{listHeading}</h3>,
        <ul key="list" >{list.map((item, key) => this.htmlToReact.parse('<li key="'+ key +'">'+ item +'</li>'))}</ul>
      ]
  }

  render() {
    const {paragraphs, heading } = this.props.info;

    return (
      <div id="CourseInfo">
        <h2 id="info-heading">{heading}</h2>
        {paragraphs.map((para, key) => {
          const paraHTML = this.htmlToReact.parse('<span>'+para+'</span>');
          return <p key={key}> {paraHTML} </p>
        })}
        {this.getList()}
        <div id="info-buttons">
          <Transition>
            {this.getButtons()}
          </Transition>
        </div>

      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    course: state.course,
    info: state.course.info,
    thinkaloud: state.thinkaloud,
    blocking: state.blocking,
    blockSummary: state.blockSummary
  };
}

export default connect(mapStateToProps, actions)(CourseInfo);



// WEBPACK FOOTER //
// ./src/components/Course/CourseInfo.js